import * as React from 'react';

const appointmentContextDefaultValues = {
    config: {
        bookAppointmentUrl: ''
    },
    store: undefined,
    appointment: undefined,
    setStore: ()=>null
    ,
    setAppointment: ()=>null
};
const CancelAppointmentContext = /*#__PURE__*/ React.createContext(appointmentContextDefaultValues);
const useCancelAppointmentContext = ()=>{
    const context = React.useContext(CancelAppointmentContext);
    if (context === appointmentContextDefaultValues) {
        throw new Error('No CancelAppointmentContext available. You might still need to wrap the application with the CancelAppointmentProvider component.');
    }
    return context;
};
CancelAppointmentContext.displayName = 'CancelAppointment';
CancelAppointmentContext.Consumer;

export { CancelAppointmentContext, appointmentContextDefaultValues, useCancelAppointmentContext };
//# sourceMappingURL=context.js.map
